<template>
    <div :class="`w-100 input-group multiselect-dropdown ${findAMatch ? 'ai-border' : ''}`">
        <div class="dropdown w-100" ref="dropdown">
            <button
                v-show="!hasCustomView"
                :class="`btn border bg-white dropdown-toggle ${disabled ? 'disabled' : ''} w-100`"
                type="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                :disabled="disabled"
            >
                <span class="message-container text-start"> {{ message }} </span>
            </button>
            <button
                :class="`btn btn-custom px-2 ${isActive ? activeClasses : 'text-muted'}`"
                v-show="hasCustomView"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                :disabled="disabled"
                @focus="toggleActiveClasses(true)"
            >
                <slot name="custom-view"></slot>
            </button>

            <div :class="`dropdown-menu p-0 ${findAMatch ? 'ai-drop-menu' : ''}`" ref="dropdownElement">
                <div class="content" v-if="options && options.length > 0">
                    <div class="border-bottom p-1 ps-2 title text-muted" v-if="title.length > 0">{{ title }}</div>
                    <div
                        class="py-1 d-flex justify-content-between border-bottom text-primary cursor-pointer"
                        v-if="hasActions"
                    >
                        <a href="javascript:void(0)" class="ps-3 text-decoration" @click="selectAll()"> Check all </a>
                        <a href="javascript:void(0)" class="pe-2 text-decoration" @click="deselectAll()">
                            Uncheck all
                        </a>
                    </div>
                    <span class="dropdown-item ps-3" v-for="(item, index) in options" :key="item.value">
                        <div class="form-check custom-checkbox">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                :id="`${name}option${item.value}${index}`"
                                :value="item.value"
                                @change="updateSelectedItems(item.value, $event)"
                                :checked="selectedItem(item.value)"
                                :disabled="disabled"
                            />
                            <label class="fw-light form-check-label" :for="`${name}option${item.value}${index}`">
                                <template v-if="showIcons">
                                    <span v-html="getView(item)"> </span>
                                </template>
                                <span class="label-content" :title="`${item.name}`">{{ item.name }}</span>
                            </label>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="./MultiSelectDropdown.scss"></style>

<script lang="ts" src="./MultiSelectDropdown"></script>
